import { useState } from "react";
import { toast } from "sonner";
import { Link } from "react-router-dom";
import { requestMagicLink } from "@/lib/api";

export default function AdminLogin() {
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const [sent, setSent] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await requestMagicLink(email);
      setSent(true);
    } catch (err) {
      if (err?.response?.status === 429) {
        toast.error("Too many attempts. Try again in 15 minutes.");
      } else {
        toast.error("Could not send. Please try again.");
      }
    } finally {
      setBusy(false);
    }
  };

  return (
    <section className="min-h-[70vh] py-24">
      <div className="mx-auto max-w-md px-4">
        <p className="catalog-label mb-4 text-center">Studio access</p>
        <h1 className="font-serif text-4xl sm:text-5xl text-center leading-tight">
          Sign in to the
          <br />
          <span className="italic text-[hsl(var(--vermillion))]">
            studio admin.
          </span>
        </h1>

        {sent ? (
          <div className="mt-10 p-6 border border-[hsl(var(--line))] bg-[hsl(var(--surface-elevated))] text-center" data-testid="magic-link-sent">
            <p className="catalog-label mb-2">Check your inbox</p>
            <p className="font-serif text-2xl leading-snug">
              A sign-in link is on its way.
            </p>
            <p className="mt-3 text-sm text-[hsl(var(--ink-muted))]">
              The link expires in 15 minutes and only works once. If you don't
              see it in a minute, check spam.
            </p>
          </div>
        ) : (
          <form onSubmit={onSubmit} className="mt-10 space-y-4" data-testid="admin-login-form">
            <label className="block">
              <span className="catalog-label mb-2 block">Email</span>
              <input
                required
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                data-testid="admin-login-email"
                autoComplete="email"
                className="w-full h-12 px-4 bg-[hsl(var(--surface))] border border-[hsl(var(--line))] focus:border-[hsl(var(--ink))] outline-none text-base"
              />
            </label>
            <button
              type="submit"
              disabled={busy}
              data-testid="admin-login-submit"
              className="w-full h-12 bg-[hsl(var(--ink))] text-[hsl(var(--bg))] font-mono text-xs uppercase tracking-widest hover:bg-[hsl(var(--vermillion))] transition-colors disabled:opacity-50"
            >
              {busy ? "Sending…" : "Send magic link"}
            </button>
            <p className="text-xs text-[hsl(var(--ink-muted))] text-center pt-2">
              Only the studio owner's email may sign in.
            </p>
          </form>
        )}

        <div className="mt-8 text-center">
          <Link
            to="/"
            className="catalog-label text-[hsl(var(--ink-muted))] hover:text-[hsl(var(--vermillion))]"
          >
            ← Back to the site
          </Link>
        </div>
      </div>
    </section>
  );
}
